import {
    afterNextRender,
    Component,
    computed,
    inject,
    signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChatTooltipComponent } from "../chat-tooltip/chat-tooltip.component";
import { Icon } from "@malirang/front-share";
import { CenterStore } from "../../../../../stores/center/center.store";
import { Router, RouterLink } from "@angular/router";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { GuardStore } from "../../../../../guards/guard.store";

@Component({
    selector: "app-child-with-service-completeness",
    templateUrl: "./child-with-service-completeness.component.html",
    styleUrls: [
        "./child-with-service-completeness.component.css",
        "../center-completeness.component.css",
    ],
    imports: [CommonModule, ChatTooltipComponent, Icon, RouterLink],
})
export class ChildWithServiceCompletenessComponent {
    readonly centerStore = inject(CenterStore);
    readonly router = inject(Router);
    readonly guardStore = inject(GuardStore);

    completenessError = this.guardStore.completenessError;
    currentCenter = this.centerStore.currentCenter;
    completeness = computed(() => this.currentCenter()?.completeness);

    navigationEnd$ = injectNavigationEnd();

    open1 = signal(false);
    open2 = signal(false);
    open3 = signal(false);

    setStyleFlag = computed(
        () =>
            this.completenessError() === "3" ||
            (!this.completeness()?.childWithService &&
                this.completeness()?.createChild),
    );

    constructor() {
        afterNextRender(() => {
            this.openTooltip();

            this.navigationEnd$.subscribe(() => {
                this.open1.set(false);
                this.open2.set(false);
                this.open3.set(false);
                this.openTooltip();
                this.handleError();
            });

            this.guardStore.completenessError$.subscribe({
                next: () => {
                    this.handleError();
                },
            });
        });
    }

    handleError() {
        const error = this.completenessError();
        const url = this.router.url;
        if (error === "3") {
            if (url.includes("/child/find") || url.includes("/child/form")) {
                return;
            }

            if (
                url.includes("segment=ticket") ||
                url.includes("/child/") ||
                url.includes("/child") ||
                url.includes("/ticket/form")
            ) {
                this.guardStore.setCompletenessError(null);
            }
            return;
        }
    }

    openTooltip() {
        const url = this.router.url;

        if (url.includes("/child/find") || url.includes("/child/form")) {
            return;
        }

        if (url.includes("segment=ticket")) {
            this.open3.set(true);
        } else if (url.includes("/child/")) {
            this.open2.set(true);
        } else if (url.includes("/child")) {
            this.open1.set(true);
        }
    }
}
